module.exports = __webpack_public_path__ + "static/media/FujiInstaxWide4.25by3.39.aa9493ae.png";